// Shared per-box image extractors. Originally paired with collectSceneImages()
// (per-scene grouping for AnimatorPanel's Redux-derived "All images" source),
// removed when Phase 3 moved that source onto the server preflight endpoint
// instead (see AnimatorPanel.jsx) — KnollingView's asset browser is the only
// remaining consumer, using the three per-box extractors below for its
// "Images" bucket.

const IMAGE_PLUGIN_IDS = new Set(["BasicImage", "HotspotImages", "HotspotsImage"]);

// Only static raster images (PNG / JPG) can be animated by Aidea Wizard. webp, gif,
// svg, mp4 and other types cannot. Returns false for a URL whose extension is a
// known non-animatable type; returns true for png/jpg/jpeg or when the type
// can't be determined (no extension — let the agent guard / modal decide).
// Still used by the canvas shortcut bar (EditorShortcuts.jsx, where this was
// originally defined); AnimatorPanel now uses the server's `animatable` flag
// instead (mirrored server-side in animate-v2-bulk.service.ts).
export function isAnimatableImageUrl(url) {
  const clean = (url || "").split("?")[0].split("#")[0].toLowerCase();
  const m = clean.match(/\.([a-z0-9]+)$/);
  if (!m) return true;
  const ext = m[1];
  return ext === "png" || ext === "jpg" || ext === "jpeg";
}

// A box's own plugin image (BasicImage / HotspotImages / HotspotsImage read
// state.url from their toolbar) — undefined when the box isn't one of these.
export function getPluginImageUrl(toolbar) {
  if (!toolbar || !IMAGE_PLUGIN_IDS.has(toolbar.pluginId)) return undefined;
  return toolbar.state?.url || undefined;
}

// <img> src urls embedded in a box's raw HTML content (legacy BasicText-style
// boxes) — data URIs excluded, same as KnollingView's original inline regex.
export function extractContentImageUrls(box) {
  if (!box?.content || typeof box.content !== "string") return [];
  const urls = [];
  for (const match of box.content.matchAll(/<img[^>]+src=["']([^"']+)["']/gi)) {
    const url = match[1];
    if (url && !url.startsWith("data:")) urls.push(url);
  }
  return urls;
}

// CSS background-image url set on a box's own style, if any (data URIs excluded).
export function extractBackgroundImageUrl(box) {
  const raw = box?.style?.backgroundImage;
  const match = raw && raw.match(/url\(['"]?([^'"]+)['"]?\)/);
  const url = match?.[1];
  return url && !url.startsWith("data:") ? url : undefined;
}
